/**
 * GitLab's unified diff of a definition file. Every line is React text
 * (escaped), never HTML: the diff is the MR author's content.
 *
 * It is the MR's per-file `diff`, which has no `---`/`+++` file headers and
 * starts at the first `@@` hunk: a line `----` is a removed YAML document
 * start (`---`), so only the first character classes a line.
 */

import type { ReactElement } from 'react';

function lineClass(line: string): string {
  if (line.startsWith('@@')) return 'def-diff__line hunk';
  if (line.startsWith('+')) return 'def-diff__line add';
  if (line.startsWith('-')) return 'def-diff__line del';
  return 'def-diff__line';
}

export function DefinitionDiff({ diff }: { diff: string }): ReactElement {
  if (diff.trim() === '') {
    return <p className="def-detail__hint">GitLab sent no diff for this file.</p>;
  }
  const lines = diff.endsWith('\n') ? diff.slice(0, -1).split('\n') : diff.split('\n');
  return (
    <pre className="def-diff" aria-label="Diff against the default branch">
      {lines.map((line, i) => (
        // Lines repeat and never reorder, so the index is the identity.
        <span key={i} className={lineClass(line)}>
          {line}
          {'\n'}
        </span>
      ))}
    </pre>
  );
}
